
import { WorldCountry } from '../types';
import { turkeyExpanded } from './turkeyExpansion';

export const middleEastExpansion: WorldCountry[] = [
  turkeyExpanded
];
